import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { PageGuard } from 'auth/context';
import { PageTemplate } from 'templates';

import { SingleLogoutPage } from 'auth/pages/slo/single-logout-page';
import { EntryPage, OrderSummaryPage } from '../pages';
import { GeneralErrorComponent } from '../pages/order-summary/components/ErrorComponents';
import { ERROR_TYPE } from '../pages/order-summary/components/ErrorComponents/components/GeneralError/constants';
import { entryPage, orderSummaryPage, sloPage } from './path-constants';

export function RouterComponent(): React.ReactElement {
  return <Router>
    <PageGuard>
      <PageTemplate>
        <Routes>
          <Route path={orderSummaryPage} element={<OrderSummaryPage />} />
          <Route path={entryPage} element={<EntryPage />} />
          <Route path={sloPage} element={<SingleLogoutPage />} />
          <Route path="*" element={<GeneralErrorComponent errorType={ERROR_TYPE.pageNotFound} />} />
        </Routes>
      </PageTemplate>
    </PageGuard>
  </Router>;
}
